async function fgwToggleFavorite(element) {
    const hasFavorite = element.dataset.hasFavorite === 'true' ? true : false;
    const productHandle = element.dataset.productHandle;
    const fullElement = element.querySelector('.favorite-full');
    const emptyElement = element.querySelector('.favorite-empty');
    if(!hasFavorite) {
        fetch(`/a/fgc/favs/add?id=${productHandle}`);
        fullElement.removeAttribute("hidden");
        emptyElement.setAttribute("hidden", true);
        element.dataset.hasFavorite = 'true';
    }
    else {
        fetch(`/a/fgc/favs/del?id=${productHandle}`);
        fullElement.setAttribute("hidden", true);
        emptyElement.removeAttribute("hidden");
        element.dataset.hasFavorite = 'false';
    }
}

async function fgwFavoritesAuth(element) {
  const productHandle = element.dataset.productHandle;
  const returnToUrl = window.location.pathname + window.location.search + window.location.hash;

  localStorage.setItem('fgw_favorites_return_url', returnToUrl);
  localStorage.setItem('fgw_favorites_product_handle', productHandle);

  window.location.href = '/account/login';
}

async function fgwFavNavAuth() {
  localStorage.setItem('fgw_favorites_return_url', "/account?view=favorites");
}

async function fgwFavoritesPostLogin() {
    const productHandle = localStorage.getItem('fgw_favorites_product_handle');
    const wishlistIcon = document.querySelector(`.toggle-favorite-button[data-product-handle="${productHandle}"]`);
    if(wishlistIcon && productHandle) {
        fgwToggleFavorite(wishlistIcon);
        localStorage.removeItem("fgw_favorites_return_url");
        localStorage.removeItem("fgw_favorites_product_handle");
    }
}

function fgwApplyReturnToOnLoginPage() {
  const returnUrl = localStorage.getItem('fgw_favorites_return_url');
  const loginForm = document.querySelector('form#customer_login');
  const registerForm = document.querySelector('form#create_customer');
  let form = null;

  if(loginForm) {
    form = loginForm;
  } else {
    form = registerForm;
  }
    
  if (form && returnUrl) {
    const hidden = form.querySelector('input[name="return_to"]');
    hidden.value = returnUrl;
    localStorage.removeItem("fgw_favorites_return_url");
  }

}
